module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres6me"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "receivedStore": _vm.receivedHres6meIndex,
      "searchBoxAlias": "request",
      "cancelEvent": _vm.cancelEvent,
      "rowDisableCondition": _vm.rowDisableCondition,
      "unLoadBool": true
    },
    model: {
      value: (_vm.searchParams),
      callback: function($$v) {
        _vm.searchParams = $$v
      },
      expression: "searchParams"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "detail": _vm.detail,
      "currentDtereq": _vm.detail.dtereq,
      "currentNumseq": _vm.detail.seqno,
      "currentCodempid": _vm.codempid,
      "toggle": _vm.toggle,
      "postHres6meSaveCancel": _vm.postHres6meSaveCancel,
      "indexSelected": _vm.indexSelected,
      "nowLang": _vm.app.nowLang,
      "searchParams": _vm.searchParams,
      "descCodapp": _vm.dash.descCodapp
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e1d361d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6me/component.vue
// module id = 3613
// module chunks = 1